var parsePhoneNumberToSwish = function parsePhoneNumberToSwish(phoneNumber) {
  return phoneNumber.replace(/^004607/, '+467').replace(/^00/, '+').replace(/^0/, '+46').replace(/^\+4607/, '+467');
};

export default parsePhoneNumberToSwish;